import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Login from './Components/Auth/login';
import Sede from './pages/Sede';
import Almacen from './pages/Almacen';
import SGI from './pages/SGI';
import Transportes from './pages/Transportes';
import Contabilidad from './pages/Contabilidad';
import ControlOperativo from './pages/ControlOperativo';
import AdministracionTI from './pages/AdministracionTI';
import HREmployeesPage from './pages/HR/Employees';
import HRAttendancePage from './pages/HR/Attendance';
import Seguridad from './pages/Seguridad';
import TotpApprovals from './pages/TotpApprovals';
import ConductorPreoperacional from './pages/ConductorPreoperacional';
import { isNativeRuntime } from './utils/runtimePlatform';

function reportSigAppDebug() {}

function IdleGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    // Deshabilitado logout automático por inactividad
    // const isLogin = location.pathname === '/';
    // if (isLogin) return; 

    // let timerId;
    // const resetTimer = () => {
    //   clearTimeout(timerId);
    //   timerId = setTimeout(() => {
    //     // navigate('/');
    //   }, 5 * 60 * 1000); // 5 minutos de inactividad
    // };

    // const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];
    // events.forEach((evt) => window.addEventListener(evt, resetTimer));

    // resetTimer();

    // return () => {
    //   clearTimeout(timerId);
    //   events.forEach((evt) => window.removeEventListener(evt, resetTimer));
    // };
  }, [location.pathname, navigate]);

  return children;
}

function NativeRouteProbe() {
  const location = useLocation();

  React.useEffect(() => {
    // Registra cada transicion de ruta dentro de la APK para confirmar si el navigate llega a montar la vista.
    reportSigAppDebug('R1', 'Cambio de ruta en APK SIG', {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      href: typeof window !== 'undefined' ? window.location.href : '',
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const nativeApp = String(process.env.REACT_APP_NATIVE_APP || '').trim().toLowerCase();
  const isNative = isNativeRuntime();
  
  let inferredBase = '/';
  if (path.startsWith('/senerfi')) inferredBase = '/senerfi';
  else if (path.startsWith('/cpanel_root')) inferredBase = '/cpanel_root';
  else if (path.startsWith('/senerfi-login')) inferredBase = '/senerfi-login';

  // Usar PUBLIC_URL si está definido (build), o inferir si es dinámico
  const publicUrl = process.env.PUBLIC_URL || '';
  // Si PUBLIC_URL es relativo (.), usar HashRouter para evitar problemas de rutas y 404s en despliegues no-root sin config de servidor
  const isRelative = publicUrl === '.' || publicUrl.startsWith('./');
  
  const Router = (isNative || isRelative) ? HashRouter : BrowserRouter;
  const base = (isNative || isRelative) ? '/' : (publicUrl || inferredBase);

  function NativeBootRedirect() {
    const navigate = useNavigate();
    React.useEffect(() => {
      try {
        if (isNative) {
          const h = window.location.hash || '';
          const p = window.location.pathname || '';
          if ((!h || h === '#' || h === '') && (!p || p === '/')) {
            navigate(nativeApp === 'sig' ? '/mobile/sig/popayan' : '/');
          }
        }
      } catch (_) {}
    }, [navigate]);
    return null;
  }
  return (
    <Router basename={base}>
      {isNative ? <NativeRouteProbe /> : null}
      {isNative && nativeApp === 'preoperacionales' ? (
        // Variante APK "Preoperacionales": app independiente para conductores,
        // con su propio login (conductores_app), sin el resto de módulos NOVA.
        <Routes>
          <Route path="*" element={<ConductorPreoperacional />} />
        </Routes>
      ) : isNative && nativeApp === 'sig' ? (
        <Routes>
          <Route path="/boot" element={<NativeBootRedirect />} />
          <Route path="/" element={<Login />} />
          <Route path="/mobile/control-operativo/:location" element={<ControlOperativo mobileMode />} />
          <Route path="/mobile/sig/:location" element={<SGI mobileMode />} />
          <Route path="*" element={<Login />} />
        </Routes>
      ) : isNative ? (
        // Variante completa del APK: mismos módulos que la web (Almacén,
        // Contabilidad, SGI, RRHH, etc.), no solo Control Operativo.
        <Routes>
          <Route path="/boot" element={<NativeBootRedirect />} />
          <Route path="/" element={<Login />} />
          <Route path="/sede/:location" element={<Sede />} />
          <Route path="/almacen/:location" element={<Almacen />} />
          <Route path="/sig/:location" element={<SGI />} />
          <Route path="/sgi/:location" element={<SGI />} />
          <Route path="/transportes/:location" element={<Transportes />} />
          <Route path="/contabilidad/:location" element={<Contabilidad />} />
          <Route path="/control-operativo/:location" element={<ControlOperativo />} />
          <Route path="/mobile/control-operativo/:location" element={<ControlOperativo mobileMode />} />
          <Route path="/administracion-ti/:location" element={<AdministracionTI />} />
          <Route path="/rrhh/empleados" element={<HREmployeesPage />} />
          <Route path="/rrhh/asistencia" element={<HRAttendancePage />} />
          <Route path="/seguridad" element={<Seguridad />} />
          <Route path="/aprobaciones-2fa" element={<TotpApprovals />} />
          <Route path="*" element={<Login />} />
        </Routes>
      ) : (
        <IdleGuard>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/sede/:location" element={<Sede />} />
            <Route path="/almacen/:location" element={<Almacen />} />
            <Route path="/sig/:location" element={<SGI />} />
            <Route path="/sgi/:location" element={<SGI />} />
            <Route path="/transportes/:location" element={<Transportes />} />
            <Route path="/contabilidad/:location" element={<Contabilidad />} />
            <Route path="/control-operativo/:location" element={<ControlOperativo />} />
            <Route path="/mobile/control-operativo/:location" element={<ControlOperativo mobileMode />} />
            <Route path="/administracion-ti/:location" element={<AdministracionTI />} />
            <Route path="/rrhh/empleados" element={<HREmployeesPage />} />
            <Route path="/rrhh/asistencia" element={<HRAttendancePage />} />
            <Route path="/seguridad" element={<Seguridad />} />
            <Route path="/aprobaciones-2fa" element={<TotpApprovals />} />
            <Route path="*" element={<Login />} />
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          </Routes>
        </IdleGuard>
      )}
    </Router>
  );
}

export default App;
